<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section class="text-center">
    <h3>Assign to staff member</h3>

    <section v-if="!loadingClinicians">
      <b-form-select v-model="clinician" class="mb-2">
        <b-form-select-option disabled value="">Select a staff member</b-form-select-option>
        <b-form-select-option v-for="user in clinicians" :value="user">{{user.name}}</b-form-select-option>
      </b-form-select>
    </section>

    <section v-else>
      <b-spinner variant="primary" label="Loading staff member"></b-spinner>
    </section>

    <section class="d-inline-flex full-width mt-2">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
      <b-button :class="{'disabled': !clinician || loading}" variant="success" @click="assignClinician()">Assign Staff member</b-button>
    </section>
  </section>
</template>
<!-- eslint-enable -->

<script>
  import PrisonUsersService from '../../../services/PrisonUsersService';
  import PostService from '../../../services/PostService';

  export default {
    components: {},
    props: {
      post: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        loadingClinicians: false,
        loading: false,
        clinician: '',
        clinicians: [],
      };
    },
    mounted() {
      this.getClinicians();
    },
    methods: {
      getClinicians() {
        this.loadingClinicians = true;
        PrisonUsersService.getClinicians().then(res => {
          this.clinicians = res.data;
        }).catch(err => {
          console.log('could not get clinicians', err);
          this.$toast.error('Could not get staff members, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loadingClinicians = false;
        });
      },
      assignClinician() {
        this.loading = true;
        PostService.assignClinician(this.post._id, {
          user_id: this.clinician.user_id, name: this.clinician.name, email: this.clinician.email }).then(() => {
         // console.log('updated clinician', res);
          this.$toast.success(`Assigned staff member: ${this.clinician.name} Successfully`, {
            toastClassName: ['toast-std', 'success-toast'],
          });
          this.$emit('refresh', true);
        }).catch(err => {
          console.log('could not assign clinician', err);
          this.$toast.error('Could not assign staff member, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
